import { render, staticRenderFns } from "./BGGRank.vue?vue&type=template&id=60b2f4de&scoped=true"
import script from "./BGGRank.vue?vue&type=script&lang=js"
export * from "./BGGRank.vue?vue&type=script&lang=js"
import style0 from "./BGGRank.vue?vue&type=style&index=0&id=60b2f4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b2f4de",
  null
  
)

export default component.exports